import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'

 const Popup = (props: any) => {
    let t = Tr()

    // add / edit facility states

    const [error, setError] = useState(Object)
    const [addloader, setaddLoader] = useState(false)
    const [disable, setDisable] = useState(false)

    const [trainTickets, setTrainTickets] = useState(
      props.passdata.data || [{en_name: '', ru_name: '', uz_name: ''}]
    )
    const addTrainTickets = async () => {
      var tmp: any = [...trainTickets, {en_name: '', ru_name: '', uz_name: ''}]
      setTrainTickets(tmp)
    }

    const hancleTrainTicketsChange = (index: number, field: string, value: string) => {
      var trainTicketsSlots: any = [...trainTickets]
      trainTicketsSlots[index][field] = value
      setTrainTickets(trainTicketsSlots)
    }

    const removeTrainTickets = (id: number, index: number) => {
      // Create a copy of the Train Tickets array

      if (id == null || id == undefined) {
        if (trainTickets.length === 1) {
          Swal.fire({
            icon: 'error',
            title: t('Cannot Remove All Rows'),
            text: t('At least one row must be present'),
          })
        } else {
          const updateTrainTickets = [...trainTickets]

          // Remove the element at the specified index
          updateTrainTickets.splice(index, 1)

          // Update the state with the new array
          setTrainTickets(updateTrainTickets)
        }
      } else {
        if (trainTickets.length === 1) {
          Swal.fire({
            icon: 'error',
            title: t('Cannot Remove All Rows'),
            text: t('At least one row must be present'),
          })
        } else {
          var tmp2 = sessionStorage.getItem('admin')
          // Step 2: Check if the item is not null
          if (tmp2) {
            // Step 3: Parse the JSON string
            var adminData = JSON.parse(tmp2)
            // Step 4: Access the adminId
            var adminId = adminData.adminId
          }

          Swal.fire({
            title: t('Are you sure?'),
            text: t('You Want To Delete this row!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Ok'),
            cancelButtonText: t('Cancel'),
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                var param: any = {
                  adminId: adminId,
                  apiName: props.passdata.apiName,
                  id: id,
                }

                const response = await fetchData('admin/deleteTickets', param)

                if (response.status == '200') {
                  const updateTrainTickets = [...trainTickets]
                  updateTrainTickets.splice(index, 1)
                  setTrainTickets(updateTrainTickets)
                  toastsuccessmsg('Deleted Successfully')
                } else {
                  toasterrormsg(response.message)
                }
              } catch (error) {
                toasterrormsg('An error occurred while processing your request.')
              }
            }
          })
        }
      }
    }

    const saveTrainTickets = async () => {
      setDisable(true)

      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      const param = {
        data: trainTickets,
        adminId: adminId,
        apiName: props.passdata.apiName,
        categoryId: props.passdata.categoryId,
      }

      var res = await fetchData('admin/addeditTickets', param)

      if (res.status == '200') {
        toastsuccessmsg('Updated Successfully')

        // setaddLoader(false)
        setDisable(false)
        props.onHide()
      } else {
        setaddLoader(false)
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
    const validate = () => {
      var errotmp: any = {}
      var err = 0

      trainTickets.forEach((trainTicketsSlot: any, index: any) => {
        if (
          trainTicketsSlot.en_name.trim() == '' ||
          trainTicketsSlot.en_name.trim() == null ||
          trainTicketsSlot.en_name.trim() == undefined
        ) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Required')
          err = 1
        } else if (trainTicketsSlot.en_name.trim().length > 50) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Too Large')
          err = 1
        } else if (
          trainTicketsSlot.ru_name.trim() == '' ||
          trainTicketsSlot.ru_name.trim() == null ||
          trainTicketsSlot.ru_name.trim() == undefined
        ) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Required')
          err = 1
        } else if (trainTicketsSlot.ru_name.trim().length > 50) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Too Large')
          err = 1
        } else if (
          trainTicketsSlot.uz_name.trim() == '' ||
          trainTicketsSlot.uz_name.trim() == null ||
          trainTicketsSlot.uz_name.trim() == undefined
        ) {
          errotmp[`uz_name${index}`] = t('Property Category Uzbek Name Is Required')
          err = 1
        }
      })

      setError(errotmp)
      if (err == 0) {
        saveTrainTickets()
      }
    }

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {props.passdata !== '' ? t('Edit') : t('Add')} {t('Filters')}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto w-100 py-10 row' id='kt_create_account_form'>
              <label className='h3 mb-5'>{t('Add Filter Values')}</label>
              <div className='row'>
                {trainTickets.map((item: any, index: any) => {
                  return (
                    <div className='col-10' key={index}>
                      <div className='row'>
                        <div className='col-lg-3 col-xl-4'>
                          <label className='required fw-bold fs-6'>{t('English Value')}</label>
                          <input
                            type='text'
                            name='enName2'
                            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            placeholder={t('English Value')}
                            value={item.en_name}
                            onChange={(event: any) =>
                              hancleTrainTicketsChange(index, 'en_name', event.target.value)
                            }
                          ></input>
                          <label className='text-danger'>{error[`en_name${index}`] || ''}</label>
                        </div>
                        <div className='col-lg-3 col-xl-4'>
                          <label className='required fw-bold fs-6'>{t('Russian Value')}</label>
                          <input
                            type='text'
                            name='trainTicketsName'
                            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            placeholder={t('Russian Value')}
                            value={item.ru_name}
                            onChange={(event: any) =>
                              hancleTrainTicketsChange(index, 'ru_name', event.target.value)
                            }
                          ></input>
                          <label className='text-danger'>{error[`ru_name${index}`] || ''}</label>
                        </div>
                        <div className='col-lg-3 col-xl-3'>
                          <label className='required fw-bold fs-6'>{t('Uzbek Value')}</label>
                          <input
                            type='text'
                            name='trainTicketsName'
                            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            placeholder={t('Uzbek Value')}
                            value={item.uz_name}
                            onChange={(event: any) =>
                              hancleTrainTicketsChange(index, 'uz_name', event.target.value)
                            }
                          ></input>
                          <label className='text-danger'>{error[`uz_name${index}`] || ''}</label>
                        </div>
                        <div className='col-lg-3 col-xl-1'>
                          <div className='col-2' style={{textAlign: 'right', marginTop: '1rem'}}>
                            <label
                              onClick={() => removeTrainTickets(item.id, index)}
                              className='btn btn-danger'
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className='row'>
                <div className='col-12' style={{textAlign: 'right'}}>
                  <label
                    className='btn btn-success'
                    onClick={() => {
                      addTrainTickets()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </label>
                </div>
              </div>

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && t('Save')}

                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}

                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* action button end */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function TrainTickets() {
  let t = Tr()
  const {menuIdAdd, menuIdEdit} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [trainTicketsList, setTrainTicketsList] = useState([])
  const [orgTrainTicketsList, setOrgTrainTicketsList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const [passdata, setPassData] = useState<{
    apiName: string
    data: any[]
    categoryId: string | null
  }>({apiName: '', data: [{en_name: '', ru_name: '', uz_name: ''}], categoryId: null})

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },

      {
        name: t('Values'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.data.map((item: any) => item.en_name).join(', ')}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.data.map((item: any) => item.en_name).join(', '),
        filter: true,
      },

      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <button
                className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                title='Edit'
                onClick={() => {
                  const trimData = (data: any[]) => {
                    return data.map((item) => ({
                      en_name: item.en_name?.trim() || '',
                      ru_name: item.ru_name?.trim() || '',
                      uz_name: item.uz_name?.trim() || '',
                      id: item.id || '',
                    }))
                  }
                  const trimmedData = trimData(row.data)

                  setPassData({apiName: row.apiName, data: trimmedData, categoryId: row.categoryId})
                  setShowPopup(true)
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  // call cuisine list api
  const trainTicketsListApiCall = async () => {
    var response: any = await fetchData('admin/trainTickets', Object)

    if (response.status == '200') {
      setTrainTicketsList(response.data)
      setOrgTrainTicketsList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Train Tickets'
    trainTicketsListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Train Tickets')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div
          className='d-flex justify-content-end col-xl-8 '
          data-kt-user-table-toolbar='base'
        ></div>
      </div>
    )
  }

  //search function
  const trainTicketsSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text === '' || text == null || text === undefined) {
      setTrainTicketsList(orgTrainTicketsList)
    } else {
      const tmp: any = orgTrainTicketsList.filter((item: any) => {
        const multiSelectLabel = item.multiSelect ? 'Multi Select' : 'Single Select'
        const valuesEnNames = item.values.map((value: any) => value.en_name.toLowerCase())

        return (
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase() === text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase() === text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase() === text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase())) ||
          multiSelectLabel.toLowerCase().includes(text.toLowerCase()) ||
          valuesEnNames.some((enName: string) => enName.includes(text.toLowerCase()))
        )
      })
      setTrainTicketsList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgTrainTicketsList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={trainTicketsList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={trainTicketsSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Train Tickets')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>
                    {t('There are no Train Tickets')}
                  </p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Train Tickets')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            passdata={passdata}
            onHide={() => {
              setShowPopup(false)
              trainTicketsListApiCall()
            }}
          />
        )}
      </div>
    </>
  )
}

export default TrainTickets
